import { Component, OnInit, ViewChild } from '@angular/core';
import { BsDropdownDirective, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AsyncPipe, NgClass, NgForOf, NgIf, SlicePipe } from '@angular/common';

import { CommonComponent } from '@components/common.component';
import { SimplebarAngularModule } from 'simplebar-angular';
import { get } from 'lodash-es';
import { notificationsActions, selectNotifications } from '@redux/notifications.redux';

@Component({
  selector: 'app-notifications-dashboard',
  standalone: true,
  imports: [BsDropdownModule, AsyncPipe, NgForOf, NgIf, SlicePipe, NgClass, SimplebarAngularModule],
  templateUrl: './notifications-dashboard.component.html',
  styleUrls: ['./notifications-dashboard.component.scss'],
})
export class NotificationsDashboardComponent extends CommonComponent implements OnInit {
  @ViewChild('dropdownNotifications') dropdown!: BsDropdownDirective;
  //
  notifications$ = this.store.select(selectNotifications.notifications);
  unread$ = this.store.select(selectNotifications.unread);
  unreadTotal$ = this.store.select(selectNotifications.unreadTotal);
  //
  onlyUnread = false;

  protected readonly get = get;

  //
  ngOnInit(): void {
    this.store.dispatch(notificationsActions.isSupported());
    this.store.dispatch(notificationsActions.notifications());
  }

  getNotifications() {
    return this.onlyUnread ? this.unread$ : this.notifications$;
  }

  onNotifications() {
    const path = this.role === 'COMMUNITY_RELATIVE' ? '/family' : '/';
    this.router.navigate([path, 'notifications']).then();
    this.dropdown.hide();
  }
}
